module.exports = __webpack_public_path__ + "img/img_1.e2f60e06.png";